import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import Img from "../../../images/locationgcc/web/connect.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

const connect = () => {
  return (
    <div className="connect_gcc_web p-100" style={{ background: "#FCFCFC" }}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="connect_head">
              <h2>
                Connect with us now and build a website for your business – make
                it a brand!
              </h2>
              <p>
                Brands are influential and make more money than ordinary
                businesses if they have a compelling website. If you want to
                build a website to meet your business objectives and establish
                an unrivaled digital presence, avail our web design Dubai and
                development services.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Connect Now To Get Started
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="TekRevol"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default connect;
